import { Link } from "react-router-dom";
import type { Work } from "@/types/media";
import { getTypeLabel } from "@/utils/media";
import { useFavoriteState } from "@/hooks/useFavorites";

interface WorkCardProps {
  work: Work;
  rank?: number;
}

export default function WorkCard({ work, rank }: WorkCardProps) {
  const favorites = useFavoriteState();
  const favorited = favorites.includes(work.id);

  return (
    <Link
      to={`/detail/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title} 影视封面`}
          title={`${work.title} - 91av视频影视资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />

        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent" />

        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
          <i className="ri-star-fill text-[11px]" />
          {work.rating.toFixed(1)}
        </span>

        {typeof rank === "number" && (
          <span className="absolute left-2 bottom-2 flex h-7 w-7 items-center justify-center rounded-md bg-primary-950/85 font-heading text-sm font-bold text-background-50">
            {rank}
          </span>
        )}

        {favorited && (
          <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-background-50/90 text-secondary-600">
            <i className="ri-bookmark-fill text-base" />
          </span>
        )}

        <span className="absolute right-2 bottom-2 rounded-md bg-background-50/15 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur-sm">
          {getTypeLabel(work.type)}
        </span>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500/90 text-background-50">
            <i className="ri-play-fill text-2xl" />
          </span>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
          {work.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {work.year} · {work.region} · {work.genres.join(" / ")}
        </p>
        <p className="mt-1 truncate text-xs text-foreground-600">{work.updatedAt} 更新</p>
      </div>
    </Link>
  );
}